<template>
  <v-dialog v-model="model" width="450">
    <div class="simple-dialog">
      <div>
        <div class="close-container">
          <button class="close-btn" @click="model = false">
            <UiIcon :icon="CloseIcon" color="BW-800" size="24"/>
          </button>
        </div>
        <div class="dialog-content">
          <div class="dialog-header">{{
              tariffData?.type == 'by_count' ? t('you_used_all_free_docs') : t('your_tariff_has_expired')
            }}
          </div>
          <div class="dialog-description">{{
              tariffData?.type == 'by_count' ? t('you_send_all_free_docs') : t('your_docs_will_be_storage_3_month')
            }}
          </div>
        </div>
      </div>
      <ui-button :to="{name: 'CabinetTariffs'}" block>{{ t('select_tariff') }}</ui-button>
    </div>
  </v-dialog>
</template>

<script setup lang="ts">
import {useI18n} from '@/shared/lib/i18n';

import * as UserModel from "../model";

import CloseIcon from "@/shared/ui/icons/action/Close.vue";

import {UiButton, UiIcon} from "@ismet/vue-ui-kit";

const model = defineModel<boolean>({
  default: false,
  required: true,
});

const {t} = useI18n();

const {data: tariffData} = UserModel.useActiveTariffBySelectedCompany();
</script>

<style scoped>
.close-container {
  display: flex;
  justify-content: flex-end;
}

.dialog-content {
  display: flex;
  flex-direction: column;
  gap: .5rem;
}

.dialog-header {
  margin: 0 2rem;
}

.dialog-description {
  margin: 0 3.75rem;
}
</style>

<i18n lang="json">
{
  "ru": {
    "you_used_all_free_docs": "Вы использовали все бесплатные документы",
    "you_send_all_free_docs": "Вы отправили 3 бесплатных документа. Чтобы продолжить работу с сервисом, выберите тариф",
    "select_tariff": "Выбрать тариф",
    "your_tariff_has_expired": "Срок дейстия тарифа истёк",
    "your_docs_will_be_storage_3_month": "Для продолжения работы с сервисом вам необходимо выбрать новый тариф"
  },
  "kk": {
    "you_used_all_free_docs": "Сіз барлық тегін құжаттарды қолдандыңыз ба",
    "you_send_all_free_docs": "Сіз 3 тегін құжат жібердіңіз. Қызметті жалғастыру үшін тарифті таңдаңыз",
    "select_tariff": "Таңдаңыз тариф",
    "your_tariff_has_expired": "Тарифтің мерзімі аяқталды",
    "your_docs_will_be_storage_3_month": "Сервисті пайдалануды жалғастыру үшін жаңа тариф таңдау қажет"
  }
}
</i18n>